import { apiClient } from 'api'
import { PlayerToTeam } from 'types/players-to-teams'

export const getPlayersToTeam = (teamId: number, leagueId: number) =>
    apiClient.get<PlayerToTeam[]>(`/players-to-teams/${teamId}/${leagueId}`)

export const addPlayerToTeam = (playerToTeam: PlayerToTeam) =>
    apiClient.post<PlayerToTeam, PlayerToTeam>('/players-to-teams', playerToTeam)

export const editPlayerToTeam = (teamId: number, leagueId: number, playerId: number, body: Partial<PlayerToTeam>) =>
    apiClient.patch<Partial<PlayerToTeam>>(`/players-to-teams/${teamId}/${leagueId}/${playerId}`, body)

export const deletePlayerToTeam = (teamId: number, leagueId: number, playerId: number) =>
    apiClient.delete(`/players-to-teams/${teamId}/${leagueId}/${playerId}`)
